const currentPageAndLastPageIsEqual = (meta) => {
    return meta.page['last-page'] <= meta.page['current-page']
}

export default currentPageAndLastPageIsEqual;